var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account-details-inner-form" },
    [
      _vm.businessRegistration == "0"
        ? _c(
            "div",
            { staticClass: "flex flex-col gap-x-4 gap-y-5 md:gap-y-7" },
            [
              _c(
                "h3",
                { staticClass: "registration-form-layout__block-title" },
                [_vm._v(_vm._s(_vm.personPrefix + _vm.subscriptionsIncome))]
              ),
              _vm._v(" "),
              _c("theme-checkboxes", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|make_choice",
                    expression: "`required|make_choice`"
                  }
                ],
                staticClass: "form__radio",
                attrs: {
                  label: _vm.subscriptionsIncome,
                  options: _vm.subscriptionsTypeOfIncomeOptions,
                  name: "person[" + [_vm.i] + "][type_of_income][]",
                  isRequired: true
                },
                on: { input: _vm.triggerWorkingForm }
              }),
              _vm._v(" "),
              _vm.income_working_state
                ? _c("theme-radios", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|make_choice",
                        expression: "`required|make_choice`"
                      }
                    ],
                    attrs: {
                      label: _vm.usersContractType,
                      name: "person[" + [_vm.i] + "][working_contract_type_id]",
                      options: _vm.usersContractTypeOptions,
                      columnDirection: true,
                      isRequired: true
                    },
                    on: { input: _vm.triggerContractDuration }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.showContractDuration
                ? _c(
                    "div",
                    { staticClass: "flex flex-col gap-x-4 gap-y-5 md:gap-y-7" },
                    [
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|numeric",
                            expression: "`required|numeric`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersContractDuration,
                          name:
                            "person[" +
                            [_vm.i] +
                            "][working_contract_duration]",
                          placeholder: _vm.usersContractDurationPlaceholder,
                          isRequired: true
                        }
                      }),
                      _vm._v(" "),
                      _c("theme-calendar", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersContractEndDate,
                          name:
                            "person[" +
                            [_vm.i] +
                            "][working_contract_end_date]",
                          placeholder: _vm.usersContractEndDatePlaceholder,
                          isRequired: true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.income_working_state || _vm.income_own_business_state
                ? _c(
                    "div",
                    {
                      staticClass:
                        "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7"
                    },
                    [
                      _c(
                        "theme-input",
                        {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|numeric",
                              expression: "`required|numeric`"
                            }
                          ],
                          attrs: {
                            label: _vm.usersMonthlyIncome,
                            name: "person[" + [_vm.i] + "][income]",
                            placeholder: "0,00",
                            isExtraInfo: true,
                            isRequired: true
                          }
                        },
                        [
                          _c("template", { slot: "extra-info" }, [
                            _c("span", { staticClass: "text-black" }, [
                              _vm._v("€")
                            ])
                          ])
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("theme-input", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "`required`"
                          }
                        ],
                        attrs: {
                          label: _vm.usersOccupation,
                          name: "person[" + [_vm.i] + "][occupation]",
                          placeholder: _vm.usersOccupationPlaceholder,
                          isRequired: true
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.income_studying_state
                ? _c("theme-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "`required`"
                      }
                    ],
                    attrs: {
                      label: _vm.usersStudy,
                      name: "person[" + [_vm.i] + "][study]",
                      placeholder: _vm.usersStudyPlaceholder,
                      isRequired: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("theme-radios", {
                attrs: {
                  label: _vm.usersDoYouHaveGuarantorGeneral,
                  name: "person[" + [_vm.i] + "][guarantor]",
                  options: _vm.usersDoYouHaveGuarantorOptions
                },
                on: { input: _vm.triggerGuarantorIncomeField }
              }),
              _vm._v(" "),
              _vm.income_guarantor_state
                ? _c("theme-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required|numeric",
                        expression: "`required|numeric`"
                      }
                    ],
                    attrs: {
                      label: _vm.usersGuarantorIncome,
                      name: "person[" + [_vm.i] + "][guarantor_income]",
                      placeholder: _vm.usersGuarantorIncomePlaceholder,
                      isRequired: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("theme-textarea", {
                attrs: {
                  label: _vm.usersExtraInformationIncome,
                  name: "person[" + [_vm.i] + "][income_note]",
                  placeholder: _vm.usersExtraInformationIncomePlaceholder,
                  rows: "4"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h3", { staticClass: "registration-form-layout__block-title" }, [
        _vm._v(_vm._s(_vm.personPrefix + _vm.usersLandlordDetails))
      ]),
      _vm._v(" "),
      _c("theme-radios", {
        attrs: {
          name: "person[" + [_vm.i] + "][landlord_status]",
          options: _vm.usersLandlordOptions
        },
        on: { input: _vm.triggerLandlordType }
      }),
      _vm._v(" "),
      _vm.landlord_type_state == "renting_property"
        ? _c(
            "div",
            { staticClass: "flex flex-col gap-x-4 gap-y-5 md:gap-y-7" },
            [
              _c("theme-input", {
                attrs: {
                  label: _vm.usersLandlordName,
                  name: "person[" + [_vm.i] + "][landlord_name]",
                  placeholder: _vm.usersLandlordNamePlaceholder
                }
              }),
              _vm._v(" "),
              _c("theme-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "email",
                    expression: "`email`"
                  }
                ],
                attrs: {
                  label: _vm.usersLandlordEmail,
                  name: "person[" + [_vm.i] + "][landlord_email]",
                  placeholder: _vm.usersLandlordEmailPlaceholder
                }
              }),
              _vm._v(" "),
              _c("theme-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "phone_number",
                    expression: "`phone_number`"
                  }
                ],
                attrs: {
                  label: _vm.usersLandlordPhone,
                  name: "person[" + [_vm.i] + "][landlord_phone_number]",
                  placeholder: _vm.usersLandlordPhonePlaceholder
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("h3", { staticClass: "registration-form-layout__block-title" }, [
        _vm._v(_vm._s(_vm.personPrefix + _vm.usersAddress))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2 md:gap-y-7"
        },
        [
          _c("theme-input", {
            ref: "person_postcode_" + _vm.i,
            staticClass: "js-postcode",
            attrs: {
              name: "person[" + [_vm.i] + "][address][post_code]",
              label:
                _vm.locales && _vm.locales.users && _vm.locales.users.post_code,
              placeholder: _vm.subscriptionsPostCodePlaceholder
            },
            on: {
              blur: function($event) {
                return _vm.checkPcHn($event, _vm.i)
              }
            }
          }),
          _vm._v(" "),
          _c("theme-input", {
            ref: "person_city_" + _vm.i,
            attrs: {
              label: _vm.locales && _vm.locales.users && _vm.locales.users.city,
              name: "person[" + [_vm.i] + "][address][city]",
              placeholder: _vm.subscriptionsCityPlaceholder
            }
          }),
          _vm._v(" "),
          _c("theme-input", {
            ref: "person_street_" + _vm.i,
            attrs: {
              label:
                _vm.locales && _vm.locales.users && _vm.locales.users.street,
              name: "person[" + [_vm.i] + "][address][street]",
              placeholder: _vm.subscriptionsStreetPlaceholder
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-3 md:gap-y-7"
        },
        [
          _c("theme-input", {
            ref: "person_housenumber_" + _vm.i,
            staticClass: "js-house-number",
            attrs: {
              label:
                _vm.locales &&
                _vm.locales.users &&
                _vm.locales.users.house_number,
              name: "person[" + [_vm.i] + "][address][house_number]",
              placeholder: _vm.subscriptionsHouseNumberPlaceholder
            },
            on: {
              blur: function($event) {
                return _vm.checkPostcodeAddress($event, _vm.i)
              }
            }
          }),
          _vm._v(" "),
          _c("theme-input", {
            attrs: {
              label: _vm.subscriptionsHouseNumberAppendix,
              name: "person[" + [_vm.i] + "][address][house_number_appendix]",
              placeholder: _vm.subscriptionsHouseNumberAppendixPlaceholder
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "registration-form-layout__block-title" }, [
        _vm._v(_vm._s(_vm.personPrefix + _vm.subscriptionsFamilyStatusTitle))
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "grid grid-cols-2 gap-x-4 gap-y-5 sm:grid-cols-4 md:gap-y-7"
        },
        [
          _c("theme-select", {
            staticClass: "col-span-full sm:col-span-2",
            attrs: {
              label: _vm.subscriptionsCivilStatus,
              name: "person[" + [_vm.i] + "][civil_state_id]",
              options: _vm.subscriptionsCivilStatusOptions,
              "show-zero-option": "0"
            }
          }),
          _vm._v(" "),
          _vm.i == 0
            ? _c("theme-select", {
                attrs: {
                  label: _vm.subscriptionsChildren,
                  name: "have_children",
                  options: _vm.subscriptionsChildrenOptions
                },
                model: {
                  value: _vm.have_children_value,
                  callback: function($$v) {
                    _vm.have_children_value = _vm._n($$v)
                  },
                  expression: "have_children_value"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.have_children_value == 1
            ? _c("theme-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|numeric|min_value:0",
                    expression: "`required|numeric|min_value:0`"
                  }
                ],
                attrs: {
                  name: "number_of_children",
                  placeholder:
                    _vm.locales &&
                    _vm.locales.subscription &&
                    _vm.locales.subscription.number_of_children_placeholder,
                  label:
                    _vm.locales &&
                    _vm.locales.subscription &&
                    _vm.locales.subscription.number_of_children,
                  isRequired: true
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.i == 0
            ? _c("theme-select", {
                attrs: {
                  label: _vm.subscriptionsPets,
                  name: "have_pets",
                  options: _vm.subscriptionsPetsOptions
                },
                model: {
                  value: _vm.have_pets_value,
                  callback: function($$v) {
                    _vm.have_pets_value = _vm._n($$v)
                  },
                  expression: "have_pets_value"
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.have_pets_value == 1
            ? _c("theme-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "`required`"
                  }
                ],
                staticClass: "col-span-full",
                attrs: {
                  label:
                    _vm.locales &&
                    _vm.locales.subscription &&
                    _vm.locales.subscription.pets_note,
                  name: "pets_note",
                  placeholder:
                    _vm.locales &&
                    _vm.locales.subscription &&
                    _vm.locales.subscription.pets_note_placeholder,
                  isRequired: true
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", { staticClass: "registration-form-layout__block-title" }, [
        _vm._v(_vm._s(_vm.personPrefix + _vm.subscriptionsExtraDetailsTitle))
      ]),
      _vm._v(" "),
      _c("theme-radios", {
        directives: [
          {
            name: "validate",
            rawName: "v-validate",
            value: "required|make_choice",
            expression: "`required|make_choice`"
          }
        ],
        attrs: {
          label: _vm.subscriptionsSexInputTitle,
          name: "person[" + [_vm.i] + "][title_id]",
          options: _vm.subscriptionsSexOptions,
          isRequired: true
        }
      }),
      _vm._v(" "),
      _c("theme-radios", {
        attrs: {
          label: _vm.locales && _vm.locales.users && _vm.locales.users.language,
          value: _vm.defaultLanguage,
          name: "person[" + [_vm.i] + "][language]",
          options: _vm.languages
        }
      }),
      _vm._v(" "),
      _vm.i == 0
        ? _c("theme-toggler", {
            attrs: {
              name: "smoking",
              label:
                _vm.locales && _vm.locales.users && _vm.locales.users.smoking
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2299554a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2299554a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/AccountDetailsInnerForm.vue
// module id = 647
// module chunks = 1